<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import loading from '@/common/mixins/loading.js'

export default {
  name: 'App',
  mixins: [loading],
  data() {
    return {
      isToasting: false,
    }
  },
  computed: {
    ...mapState(['msgBox']),
  },
  watch: {
    msgBox(val) {
      if (val && val.msg && !this.isToasting) {
        console.log('App')
        this.toggleToast()
        console.log('msgBox>>', val)
        const toast = this.$createGoToast({
          text: val.msg,
          type: val.type || 'txt',
          onClose: () => {
            this.isToasting = false
          },
        })
        toast.show()
      }
    },
  },
  methods: {
    toggleToast() {
      this.isToasting = !this.isToasting
    },
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
